import cloneDeep from "lodash/cloneDeep";
import set from "lodash/set";

/**
 * Walk instantiated Form.io components and merge each field's dataValue at its runtime path
 * into a clone of submission.data. Fixes cases where submission.data is stale vs the UI
 * (columns, datetime widgets, partial onChange, etc.).
 *
 * @param {object | null | undefined} formio - Form.io webform instance
 * @returns {Record<string, unknown>}
 */
export function snapshotFormioInstanceData(formio) {
  if (!formio) return {};
  const base = cloneDeep(formio.submission?.data || formio._submission?.data || {});
  const roots =
    typeof formio.getComponents === "function" ? formio.getComponents() : formio.components;
  if (!Array.isArray(roots)) return base;

  const walk = (list) => {
    if (!Array.isArray(list)) return;
    list.forEach((inst) => {
      if (!inst) return;
      const nested =
        typeof inst.getComponents === "function" ? inst.getComponents() : inst.components;
      if (Array.isArray(nested) && nested.length) {
        walk(nested);
      }
      const c = inst.component;
      if (!c || c.input !== true || !inst.key) return;
      if (["button", "submit", "htmlelement", "content", "datasource", "dsbutton"].includes(c.type)) {
        return;
      }
      const p = typeof inst.path === "string" && inst.path ? inst.path : inst.key;
      if (!p) return;
      let v;
      try {
        v = inst.dataValue;
      } catch {
        return;
      }
      if (v === undefined && typeof inst.getValue === "function") {
        try {
          v = inst.getValue();
        } catch {
          v = undefined;
        }
      }
      if (v !== undefined) {
        set(base, p, v);
        if (typeof inst.key === "string" && inst.key && inst.key !== p) {
          set(base, inst.key, v);
        }
      }
    });
  };

  walk(roots);
  return base;
}
